/**
 * admin.ts — Gestão de usuários do TENANT pelo admin (fase Admin comum).
 *
 * Mesmo shape de usuário do super admin; o escopo (só o próprio tenant) é
 * garantido pelo backend.
 */

import type { components } from './generated/api'
import { api } from './http'

export type UsuarioSistema = components['schemas']['UsuarioSistema']
export type UsuarioInput = components['schemas']['UsuarioInput']
export type CriacaoUsuarioInput = components['schemas']['CriacaoUsuarioInput']
export type ConfiguracaoAdmin = components['schemas']['ConfiguracaoAdmin']

export function configuracaoAdmin() {
  return api<ConfiguracaoAdmin>('/api/v1/admin/configuracao')
}

export function usuariosDoTenant() {
  return api<UsuarioSistema[]>('/api/v1/admin/usuarios')
}

export function criarUsuario(dados: CriacaoUsuarioInput) {
  return api<UsuarioSistema>('/api/v1/admin/usuarios', {
    method: 'POST',
    body: dados,
  })
}

export function editarUsuario(id: number, dados: UsuarioInput) {
  return api<UsuarioSistema>(`/api/v1/admin/usuarios/${id}`, {
    method: 'PUT',
    body: dados,
  })
}

export function excluirUsuario(id: number) {
  return api<{ removido: boolean }>(`/api/v1/admin/usuarios/${id}`, {
    method: 'DELETE',
  })
}
